<div (click)="openModel()" class="picker-element" [class.disabled]="disabled">{{text}}
    <i class="fas fa-caret-down icon"></i>
</div>
<input style="display: none;" type="number" [(ngModel)]="model" (ngModelChange)="modelChange.emit(model)">